<template>
  <div class="page-main">
    <e-tabs :list="this.$constant.tabListRole()" isJump />
    <div>
      <!-- 表格操作条 -->
      <vxe-toolbar ref="refToolbar" size="mini" :loading="tableOptions.loading">
        <template #buttons>
          <el-button type="primary" size="mini" @click="batchDo('启用')"> 启用 </el-button>
          <el-button type="info" size="mini" @click="batchDo('禁用')"> 禁用 </el-button>
          <el-button type="danger" size="mini" @click="batchDo('删除')"> 删除 </el-button>
        </template>
        <template #tools>
          <el-button type="success" size="mini" @click="itemAdd()"> 新增文档分类 </el-button>
        </template>
      </vxe-toolbar>

      <!-- 表格 -->
      <vxe-grid
        v-if="!this.tableOptions.loading"
        ref="refTable"
        v-bind="tableOptions"
        @keydown="tableKeydown"
        @current-change="tableCurrentChange"
        @checkbox-all="checkAll"
      >
        <!-- slot_default -->
        <template #default_ststus="{ row }">
          <el-switch type="primary" v-model="row.status" @change="itemSwitch(row)" />
        </template>
        <template #default_sub_operate="{ row }">
          <el-link type="success" @click="itemAdd(row)">新增下级分类</el-link>
        </template>
        <template #default_operate="{ row }">
          <el-link type="primary" @click="itemEdit(row)">编辑</el-link>
          <el-link type="danger" @click="itemDelete(row)">删除</el-link>
        </template>
      </vxe-grid>

      <!-- 弹窗-增改文档分类 -->
      <PopupDoCategory
        v-if="isShowPopupDoCategory"
        :show.sync="isShowPopupDoCategory"
        :parentId="parentId"
        :parentName="parentName"
        :detailId="detailId"
        @success="getListData"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PopupDoCategory: () => import('./common/popup-do-category')
  },
  data() {
    return {
      tableOptions: {
        loading: false,
        size: 'mini',
        border: true,
        height: this.$util.getViewHeight() - 176,
        checkboxConfig: {
          labelField: 'name',
          checkStrictly: true,
          showHeader: true,
          checkField: 'checked'
        },
        treeConfig: {
          expandAll: true,
          transform: true,
          rowField: 'id',
          parentField: 'parent_id'
        },
        columns: [
          {
            treeNode: true,
            type: 'checkbox',
            title: '文档分类名称',
            align: 'left',
            width: 400
          },
          { field: 'remark', title: '文档分类描述' },
          {
            field: 'create_date',
            title: '创建时间',
            width: 160
          },
          {
            field: 'update_date',
            title: '更新时间',
            width: 160
          },
          {
            field: 'status',
            title: '状态',
            width: 80,
            slots: { default: 'default_ststus' }
          },
          { title: '下级分类操作', width: 160, slots: { default: 'default_sub_operate' } },
          { title: '分类操作', width: 160, slots: { default: 'default_operate' } }
        ],
        data: []
      },
      isShowPopupDoCategory: false,
      parentId: '',
      parentName: '',
      detailId: '',
      detailData: {}
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    // 获取列表数据
    getListData() {
      this.tableOptions.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/workFenLei2/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          filterData: {},
          sortData: { id: 'asc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableOptions.data = res.data.page.list.map((item) => {
              return {
                ...item,
                checked: false
              }
            })
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    // 获取-当前单选行
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setCheckboxRow(params.row, true) // 选中checkbox
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowCheckbox = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isCurrentRowCheckbox) // 选中checkbox
      }
    },
    // 递归获取所有树形数据
    getAllTreeData(data) {
      let result = []
      data.forEach((item) => {
        result.push(item)
        if (item.children && item.children.length > 0) {
          result = result.concat(this.getAllTreeData(item.children))
        }
      })
      return result
    },
    checkAll({ checked }) {
      const $grid = this.$refs.refTable
      const allData = this.getAllTreeData($grid.getTableData().fullData)
      // 手动设置选中状态
      allData.forEach((row) => {
        row.checked = checked
      })

      // 强制刷新表格
      $grid.updateData()
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 项-新增
    itemAdd(row) {
      if (row === undefined) {
        this.parentId = ''
        this.parentName = ''
      } else {
        this.parentId = row.id
        this.parentName = row.name
      }
      this.detailId = ''
      this.isShowPopupDoCategory = true
    },
    // 项-修改
    itemEdit(row) {
      this.parentId = row.parent_id || ''
      this.parentName = row.parent_name || ''
      this.detailId = row.id
      this.isShowPopupDoCategory = true
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm('您确认要删除该数据?', '提示')
        .then(() => {
          let params = {
            ids: [row.id],
            type: '删除'
          }
          this.batchDoConfirm(params)
        })
        .catch(() => {})
    },
    // 项-切换状态
    itemSwitch(row) {
      let params = {
        ids: [row.id],
        type: row.status ? '启用' : '禁用'
      }
      this.batchDoConfirm(params)
    },
    // 批量-切换状态
    batchDo(type) {
      let rows = this.getCheckboxRecords()
      if (rows.length) {
        this.$confirm(`您确认要 "批量${type}" 选中的 "${rows.length}" 项数据?`, '提示')
          .then(() => {
            let params = {
              ids: rows.map((item) => item.id),
              type
            }
            this.batchDoConfirm(params)
          })
          .catch(() => {})
      } else {
        this.itemChoosePrompt()
      }
    },
    // 批量操作-确认
    batchDoConfirm(data) {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/workFenLei2/batch',
        data
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('操作成功')
          this.getListData()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
